.inlineForm {
  display: flex;
  gap: 8px;
  align-items: stretch;
}

.inlineForm input {
  flex: 1;
  min-width: 0;
}

.primaryButton,
.removeButton,
.iconButton {
  min-height: 38px;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--token-accent) 45%, transparent);
  font-family: var(--token-font-ui);
  font-weight: 700;
  cursor: pointer;
}

.primaryButton {
  padding: 0 18px;
  background: var(--token-accent);
  color: var(--token-card-bg);
}

.removeButton {
  padding: 0 12px;
  background: rgba(176, 58, 46, 0.08);
  color: rgba(176, 58, 46, 0.95);
  border-color: rgba(176, 58, 46, 0.35);
}

.iconButton {
  width: 38px;
  background: rgba(255, 255, 255, 0.68);
  color: var(--token-text-primary);
}

.primaryButton:disabled,
.removeButton:disabled,
.iconButton:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.error {
  margin: 2px 0 0;
  color: rgba(176, 58, 46, 0.95);
  font-family: var(--token-font-ui);
  font-size: 12px;
  line-height: 1.35;
}

.linkList {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.linkRow {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  min-width: 0;
  padding: 8px 10px;
  border-radius: 14px;
  border: 1px solid rgba(28, 38, 32, 0.13);
  background: rgba(255, 255, 255, 0.58);
}

.favicon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  object-fit: contain;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  background: rgba(28, 38, 32, 0.06);
}

.linkText {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.linkText strong {
  font-family: var(--token-font-ui);
  color: var(--token-text-primary);
  font-size: 13px;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.linkText span {
  font-family: var(--token-font-body);
  color: rgba(28, 38, 32, 0.62);
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rowActions {
  display: flex;
  gap: 5px;
  align-items: center;
}

.empty {
  margin: 0;
  padding: 18px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.5);
  color: rgba(28, 38, 32, 0.68);
  font-family: var(--token-font-body);
}
